<script>
import { onMount } from 'svelte';
  import Header from './components/Header.svelte';
  import Hero from './components/Hero.svelte';
  import Services from './components/Services.svelte';
  import AboutMe from './components/AboutMe.svelte';
  import Contact from './components/Contact.svelte';
  import Footer from './components/Footer.svelte';

 onMount(() => {
    // Funzione per scrollare all'inizio
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.body.scrollTop = 0; // Per Safari
      document.documentElement.scrollTop = 0; // Per Chrome, Firefox, IE e Opera
    };

    // Esegui immediatamente
    scrollToTop();

    // Esegui di nuovo dopo un breve ritardo
    setTimeout(scrollToTop, 100);

    // Esegui ancora una volta dopo che tutti gli asset sono caricati
    window.addEventListener('load', scrollToTop);

    // Previeni il ripristino della posizione di scroll
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    // Opzionale: aggiungi un listener per l'orientamento del dispositivo
    window.addEventListener('orientationchange', () => {
      setTimeout(scrollToTop, 100);
    });

    return () => {
      window.removeEventListener('load', scrollToTop);
      window.removeEventListener('orientationchange', scrollToTop);
    };
  });
</script>

<Header />
<main>
  <Hero />
  <Services />
  <AboutMe />
  <Contact />
</main>
<Footer />

<svelte:head>
  <link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,500;1,600;1,700&family=Maname&display=swap" rel="stylesheet">

<meta name="description" content="Eleonora Ceroni, psicologa Faenza. Offro supporto psicologico per adulti e adolescenti. Contattami per un primo colloquio." />
</svelte:head>

<style>
  :global(:root) {
     --primary-color: #f4c0af; /*#db7093;*/ /* Pale violet red */
    --secondary-color: #ffe7e9; /*#ffc0cb;*/ /* Pink */
    --text-color: #666a52; /*#4a4a4a;*/ /* Dark gray */
    --background-color: white; /* Lavender blush #fbf3e4*/
    --accent-color: #cf7074;/*#ff69b4;*/ /* Hot pink */
    --leaf-color: #588157; /* Verde delle foglie */
    --flower-color: #d58bab; /* Rosa dei fiori */
  }

  :global(body) {
    font-family: 'Cormorant Garamond', sans-serif;
    line-height: 1.6;
    color: var(--text-color);
    margin: 0;
    padding: 0;
    background-color: var(--background-color);
  }

  :global(h1, h2, h3) {
    font-family: 'Cormorant Garamond', sans-serif;
    color: var(--text-color);
  }

  main {
    max-width: 100%;
    margin: 0 auto;
  }
</style>

